export async function tryGetPublicIpAddress(): Promise<string | undefined> {
  try {
    const response = await fetch("https://api.ipify.org?format=json");

    return ((await response.json()) as { ip?: string })?.ip;
  } catch {
    return Promise.resolve(undefined);
  }
}
